import { eGatewayType_enum } from "@/graphql/types";
import { ApolloClient } from '@/utils/ApolloClient';
import { gql } from "@apollo/client/core";

export async function isGatewayType(gatewayID: string, type: eGatewayType_enum) {
  const response = await ApolloClient.query({
    query: gql`
      query GQL_GET_GATEWAY_TYPE($id: String!) {
        gateway(id: $id) {
          id
          type
        }
      }
    `,
    variables: {
      id: gatewayID
    },
    fetchPolicy: 'cache-first'
  })
  return response?.data?.gateway?.type === type
}
